import React, { useState, useEffect } from 'react';
import Loading from '../Loading';
import PageWrapper from '../PageWrapper';
import { useKambiBootstrap } from './hooks/use-kambi-bootstrap';
import { useKambiScroll } from './hooks/use-kambi-scroll';
import { ErrorOverlay } from './components/ErrorOverlay';
import './styles.scss';

export const KambiSportsbook = () => {
  useKambiBootstrap();
  useKambiScroll();
  const [label, setLabel] = useState('');

  useEffect(() => {
    const timer5s = setTimeout(() => {
      setLabel('Cargando');
    }, 4000);

    const timer8s = setTimeout(() => {
      setLabel('Un momento por favor');
    }, 7000);

    return () => {
      clearTimeout(timer5s);
      clearTimeout(timer8s);
    };
  }, []);

  return (
    <PageWrapper>
      <div className="book-kambi-container">
        <div id="KambiBC" />
        <ErrorOverlay />
      </div>

      <div className="book-kambi-spinner-container">
        <div className="book-kambi-spinner">
          <Loading label={label} />
        </div>
      </div>
    </PageWrapper>
  );
};
